export class TenDLCCampaignModal extends HTMLElement {
  constructor(campaign, site, updatedCampaign) {
    super();
    this.campaign = campaign;
    this.site = site;
    this.updatedCampaign = updatedCampaign;
  }

  connectedCallback() {
    if(this.campaign.tnid_campaign == null) {
      this.renderSetupModal();
    } else {
      this.innerHTML = `
        <style>
          .ten_dlc_campaign_detail_open:hover {
            cursor: pointer;
          }
        </style>
        <div>
          <label class="fa-solid fa-check ten-dlc-enabled-icon">
          </label> <label>10DLC Enabled</label>
          <a class="fas fa-external-link ten_dlc_campaign_detail_open"></a>
        </div>`;

      this.querySelector('.ten_dlc_campaign_detail_open').addEventListener('click', function() {
        let detail = new TenDLCCampaignDetail(this.campaign.id, this.deleteCampaign.bind(this));
        this.appendChild(detail);
      }.bind(this))
    }

    // this.setStep(1)
  }

  renderSetupModal() {
    this.innerHTML = 
      `
      <button class="btn btn-primary pull-right" id="ten-dlc-campaign-button">Add 10DLC Campaign</button>
      <div class="modal fade bd-example-modal-sm" id="10DLCCampaignModal" data-cy="" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add 10DLC Campaign</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="errors"></div>
              <div class="row">
                <div class="col-sm-12">
                  <label>Vertical/Industry</label>
                  <select id="ten_dlc_campaign_vertical" class="form-control">
                    <option value="null">Select</option>
                    <option value="PROFESSIONAL">Professional</option>
                    <option value="REAL_ESTATE">Real Estate</option>
                    <option value="HEALTHCARE">Healthcare</option>
                    <option value="HUMAN_RESOURCES">Human Resources</option>
                    <option value="ENERGY">Energy</option>
                    <option value="ENTERTAINMENT">Entertainment</option>
                    <option value="RETAIL">Retail</option>
                    <option value="TRANSPORTATION">Transportation</option>
                    <option value="AGRICULTURE">Agriculture</option>
                    <option value="INSURANCE">Insurance</option>
                    <option value="POSTAL">Postal</option>
                    <option value="EDUCATION">Education</option>
                    <option value="HOSPITALITY">Hospitality</option>
                    <option value="FINANCIAL">Financial</option>
                    <option value="POLITICAL">Political</option>
                    <option value="GAMBLING">Gambling</option>
                    <option value="LEGAL">Legal</option>
                    <option value="CONSTRUCTION">Construction</option>
                    <option value="NGO">NGO</option>
                    <option value="MANUFACTURING">Manufacturing</option>
                    <option value="GOVERNMENT">Government</option>
                    <option value="TECHNOLOGY">Technology</option>
                    <option value="COMMUNICATION">Communication</option>
                  </select>
                  <label>Campaign Use Case Description</label>
                  <input id="ten_dlc_campaign_description" class="form-control" placeholder="Describe what you will be using this campaign case for.">
                  

                  </select>
                  <label>Sample Messages</label>
                  <div class="ten-dlc-sample-message-container">
                    <ten-dlc-sample-message></ten-dlc-sample-message>
                  </div>
                </div>
                <div class="col-sm-12">
                  <button type="button" class="btn btn-primary save_10dlc pull-right detail-row-button" data-cy="">Save</button>
                  <button type="button" data-dismiss="modal" class="btn btn-outline-secondary cancel_10dlc pull-right detail-row-button">Cancel</button>
                </div>
              </div>
              <div class="modal_loading hidden">
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      `;

    this.querySelector('#ten-dlc-campaign-button').addEventListener('click', function(e) {
      e.preventDefault();
      $("#10DLCCampaignModal").modal('show');
    }.bind(this))

    this.querySelector(".save_10dlc").addEventListener("click", function(e) {
      if(this.validate()) {
        this.save();
      }
    }.bind(this));
  }

  async save() {
    this.querySelector('.modal-body .row').classList.add('hidden');
    this.querySelector('.modal_loading').classList.remove('hidden');
    let sample_messages = [];
    this.querySelectorAll("ten-dlc-sample-message input").forEach((elem) => {
      sample_messages.push(elem.value);
    });
    let campaign = {
      "brandId": this.site.tnid_brand.tnid_brand_id,
      "vertical": this.querySelector("#ten_dlc_campaign_vertical").value,
      "description": this.querySelector("#ten_dlc_campaign_description").value,
      "sampleMessages":sample_messages,
      "phoneNumbers": [`${this.campaign.did}`]
    }

    let res = await fetch(`/admin/campaigns/${this.campaign.id}/10dlc`, {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'POST',
      body: JSON.stringify(campaign)
    })

    let response = await res.json();
    if(res.ok) {
      $("#10DLCCampaignModal").modal('hide');
      this.updatedCampaign(response);
      this.campaign = response;
      this.connectedCallback();
    } else {
      this.querySelector('.modal-body .row').classList.remove('hidden');
      this.querySelector('.modal_loading').classList.add('hidden');
      this.querySelector(".errors").innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> An unknown error occured trying to save your brand.
                                                  </div>`
    }
  }

  validate() {
    let found_errors = false;
    this.querySelectorAll("input, textarea").forEach(function(elem) {
      elem.classList.remove("error");
      if(elem.offsetParent != null && elem.value == "") {
        found_errors = true;
        elem.classList.add("error");
      }
    });

    this.querySelectorAll("select").forEach(function(elem) {
      elem.classList.remove("error");
      if(elem.offsetParent != null && elem.value == "null") {
        found_errors = true;
        elem.classList.add("error");
      }
    });

    this.querySelectorAll("input.email").forEach(function(elem) {
      elem.classList.remove("error");
      if(elem.offsetParent != null && !Common.validateEmail(elem.value)) {
        found_errors = true;
        elem.classList.add("error");
      } 
    })

    return !found_errors;
  }

  async deleteCampaign() {
    let res = await fetch(`/admin/campaigns/${this.campaign.id}/10dlc?tnid_campaign_id=${this.campaign.tnid_campaign.tnid_campaign_id}`, {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'DELETE'
    })

    let response = await res.json();
    if(res.ok) {
      this.updatedCampaign(response);
      this.campaign = response;
      this.connectedCallback();
      $("#10DLCCampaignModal").modal('hide');
    } else {
      console.log("UNABLE TO DELETE")
    }
  }
}

customElements.define('ten-dlc-campaign-modal', TenDLCCampaignModal)

class TenDLCSampleMessage extends HTMLElement {
  constructor() {
    super();
    this.addMessage = this.addMessage.bind(this);
    this.removeMessage = this.removeMessage.bind(this);
  }
  connectedCallback() {
    this.innerHTML = 
      `
      <style>
        .ten-dlc-sample-message-buttons {
          padding: 5px 0 0 15px !important;
          font-size: 18px;
        }
      </style>
      <div class="row">
        <div class="col-sm-10 no-gutters">
          <input type="text" class="form-control" placeholder="This is the sample message you plan to send to your customer." maxlength="160">
        </div>
        <div class="col-sm-2 ten-dlc-sample-message-buttons">
          <a class="remove_sample_message"><span class="fa fa-minus"></span></a>
          <a class="add_sample_message"><span class="fa fa-plus"></span></a>
        </div>
      </div>
      `;
    this.querySelector(".add_sample_message").addEventListener("click", this.addMessage)
    this.querySelector(".remove_sample_message").addEventListener("click", this.removeMessage.bind(this))
  }
  addMessage() {
    let ten_dlc_sample_message = new TenDLCSampleMessage();
    this.closest(".ten-dlc-sample-message-container").appendChild(ten_dlc_sample_message);
  }

  removeMessage() {
    this.closest(".ten-dlc-sample-message-container").removeChild(this)
  }
}

customElements.define('ten-dlc-sample-message', TenDLCSampleMessage)

class TenDLCCampaignDetail extends HTMLElement {
  constructor(campaign_id, deleteCampaign) {
    super();
    this.campaign_id = campaign_id;
    this.deleteCampaign = deleteCampaign;
  }
  async connectedCallback() {
    this.loadingWheel();
    $("#10DLCCampaignDetail").modal('show');
    let res = await fetch(`/admin/campaigns/${this.campaign_id}/10dlc`);
    let data = await res.json();
    if(data.error) {
      Common.notify('Sorry, there was an error loading 10DLC Campaign', 'error');
      return
    }
    let vertical = data.vertical.split('_').map(str => {
      return str[0] + str.substring(1).toLowerCase()
    }).join(' ');
    let sampleMessages = data.sampleMessages.map(msg => `<li>${msg}</li>`).join('');
    this.querySelector('.modal-body').innerHTML = 
      `
      <div class="row">
        <div class="col-sm-12">
          <label>Vertical/Industrye</label>
          <p>${vertical}</p>
          <label>Campaign Use Case Description</label>
          <p>${data.description}</p>
          <label>Sample Messages</label>
          <ul class="sample_message_detail_container">
            ${sampleMessages}
          </ul>
        </div>
        <div class="col-sm-12">
          <!--button type="button" class="btn btn-danger delete pull-right detail-row-button">Delete</button-->
          <button type="button" class="btn btn-outline-secondary cancel pull-right detail-row-button">Close</button>
        </div>
      </div>
      `;

    this.querySelector('.close').addEventListener('click', function() {
      this.remove();
    }.bind(this))

    this.querySelector('.cancel').addEventListener('click', function() {
      this.querySelector('.close').click();
    }.bind(this))

    // this.querySelector('.delete').addEventListener('click', async function() {
    //   this.querySelector('.close').click();
    //   if(await confirmPlus(`Are you sure you want to delete this 10DLC Campaign?`)) {
    //     this.deleteCampaign();
    //     console.log('10DLC deleted')
    //   }
    // }.bind(this))
  }
  loadingWheel() {
    this.innerHTML = `
    <div class="modal fade bd-example-modal-sm" id="10DLCCampaignDetail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">10DLC Detail</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="modal_loading">
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('ten-dlc-campaign-detail', TenDLCCampaignDetail)